import React from 'react'
import { Modal } from 'react-bootstrap'
import PaymentSection from './PaymentSection'

interface Props {
    show: boolean,
    onClose: () => void,
    reservationId: string
}

const AddPaymentDialog: React.FC<Props> = ({ show, onClose, reservationId }) => {
    return (
        <Modal show={show} onHide={onClose} centered size="xl">
            <Modal.Header closeButton>
                <Modal.Title>Add Payment</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <PaymentSection reservationId={reservationId} />
                {/* <ChangeStatusFormComponent reservationId={reservationId} onClose={onClose} /> */}
            </Modal.Body>
        </Modal>
    )
}

export default AddPaymentDialog